/** @jsx jsx */

import { jsx, Text } from 'theme-ui'
import styled from '@emotion/styled'

const StyledBody = styled(Text)``

const Body = ({ children, ...props }) => {
  return <StyledBody {...props}>{children}</StyledBody>
}

export default Body
